import ApexCharts from "apexcharts";

function renderEasyEntityTimeline(dataUrl, entityId) {
  const icon = (name) => '<span class="icon ds-legacy-icon ds-legacy-icon__' + name + '"></span>';

  const tools = {
    zoomin: icon('zoom-plus'),
    zoomout: icon('zoom-minus'),
    zoom: icon('search'),
    pan: icon('tool-hand'),
    reset: icon('repeat'),
    download: icon('menu'),
  };

  fetch(dataUrl).then((response) => response.json()).then((payload) => {
    if (payload.data.length <= 1) return;

    document.querySelector('#easy_entity_timeline_notice').removeAttribute('style');
    const height = (50 + (50 * payload.axis_x_count)) + "px";

    let options = {
      chart: {
        height: height,
        type: 'rangeBar',
        stacked: false,
        toolbar: {
          show: true,
          tools: tools,
          export: {
            svg: { filename: entityId },
            png: { filename: entityId },
          },
        },
        zoom: {
          enabled: true,
          allowMouseWheelZoom: false,
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, obj) {
          return obj.w.config.series[obj.seriesIndex].data[obj.dataPointIndex].z.desc;
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '80%',
          states: {
            hover: {
              filter: {
                type: 'none'
              }
            }
          }
        }
      },
      series: [{data: []}],
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeUTC: true
        }
      },
      fill: {
        type: 'solid'
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left'
      },
      tooltip: {
        custom: function ({series, seriesIndex, dataPointIndex, w}) {
          var data = w.config.series[seriesIndex].data[dataPointIndex];
          var esc = function(s) { var el = document.createElement('span'); el.textContent = s || ''; return el.innerHTML; };
          return '<div class="apexcharts-tooltip-title">' + esc(data.x) + ': ' + esc(data.z.desc) + '</div>' +
            '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex;">' +
            '  <div class="apexcharts-tooltip-text">' +
            '    <div class="apexcharts-tooltip-y-group">' +
            '      <span class="apexcharts-tooltip-text-y-label">' +
                     data.z.startFormatted + ' — ' + data.z.endFormatted +
            '      </span>' +
            '    </div>' +
            '  </div>' +
            '</div>';
        }
      }
    }

    const timelineEl = document.querySelector('#easy_entity_timeline');
    const getTimelineColors = () => {
      const style = timelineEl ? getComputedStyle(timelineEl) : getComputedStyle(document.documentElement);
      return [
        style.getPropertyValue('--easy__color--main').trim(),
        style.getPropertyValue('--easy__color-palette--base-10').trim(),
        style.getPropertyValue('--easy__color--important').trim(),
        style.getPropertyValue('--easy__color-palette--base-5').trim(),
        style.getPropertyValue('--easy__color-palette--base-2').trim()
      ];
    };
    const colors = getTimelineColors();
    let color_idx = 0;

    payload.data.forEach(element => {
      let item = {
        x: element["axis_x_label"],
        y: [
          new Date(element["start"]).getTime(),
          new Date(element["end"]).getTime()
        ],
        z: {
          desc: element["axis_y_label"],
          startFormatted: element["start_formatted"],
          endFormatted: element["end_formatted"]
        },
        fillColor: colors[color_idx]
      }

      color_idx += 1;
      if (color_idx >= colors.length) color_idx = 0;

      options["series"][0]["data"].push(item);
    });

    let chart = new ApexCharts(document.querySelector('#easy_entity_timeline'), options);
    chart.render();

    const applyThemeColors = () => {
      const colors = getTimelineColors();
      const data = options.series[0].data;
      data.forEach((item, i) => {
        item.fillColor = colors[i % colors.length];
      });
      chart.updateOptions({ series: [{ data: data }] }, true, false);
    };

    const observer = new MutationObserver(() => { applyThemeColors(); });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
  });
}

function initEasyEntityTimeline() {
  const el = document.getElementById("easy_entity_timeline");
  if (!el || !el.dataset.timelineUrl || el.dataset.timelineInitialized) return;

  el.dataset.timelineInitialized = "true";
  renderEasyEntityTimeline(el.dataset.timelineUrl, el.dataset.entityId);
}

initEasyEntityTimeline();
